"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseProperty =
/** @class */
function () {
  function BaseProperty() {
    this._blackListedAttr = ['_blackListedAttr'];
  }

  BaseProperty.prototype.getContentModelJsonSpec = function () {
    return this.toJSON(
    /* saveToContentModel */
    true);
  };

  BaseProperty.prototype.getMSTJsonSpec = function () {
    return this.toJSON(
    /* saveToContentModel */
    false);
  };

  BaseProperty.prototype.asString = function () {
    return JSON.stringify(this);
  };

  BaseProperty.prototype.toJSON = function (saveToContentModel) {
    var _this = this;

    var obj = {};
    var keys = Object.keys(this);
    keys.forEach(function (key) {
      // Do not dump out attribute in black list
      if (!_this._blackListedAttr.includes(key)) {
        if (_this[key] instanceof Array) {
          obj[key] = [];

          _this[key].forEach(function (value) {
            var result = value instanceof BaseProperty ? value.toJSON(saveToContentModel) : value;

            if (result) {
              obj[key].push(result);
            }
          });
        } else if (_this[key] instanceof BaseProperty) {
          obj[key] = _this[key].toJSON(saveToContentModel);
        } else if (typeof _this[key] !== 'undefined') {
          obj[key] = _this[key];
        }
      }
    });
    return obj;
  };

  return BaseProperty;
}();

exports.default = BaseProperty;
